import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {
            bannerText1: "We provide a planning services and specific advice",
            bannerText2: "for international small and big companies",
            contactUs: "Contact Us",
            aboutUs: "About",
            privateArea: "Private Area",
            projects: "Projects",
            contacts: "Contacts",
            links: "Links",
            italy: "Italy",
            send: "Send",
            address: "Address",
            solutions: "Services",
            titleCarouselHome1: "Services",
            titleCarouselHome2: "Design",
            titleCarouselHome3: "Consulting",
            textCarouselHome1: "",
            textCarouselHome2: "",
            textCarouselHome3: "",
            comuneMisterbianco: "Comune di Misterbianco",
            comuneBelpasso: "Comune di Belpasso",
            comuneBronte: "Comune di Bronte",
            comunePaterno: "Comune di Paternò",
            comuneBiancavilla: "Comune di Biancavilla",
            comuneMessina: "Comune di Messina",
            ternaSpa: "Terna SpA",
            cardilloAlluminio: "Cardillo Alluminio"
        }
    },
    it: {
        translation: {
            bannerText1: "Forniamo un servizio di progettazione e consulenza su specifica",
            bannerText2: "per piccole e grandi aziende, italiane ed internazionali",
            contactUs: "Contattaci",
            aboutUs: "Chi siamo",
            privateArea: "Area privata",
            projects: "Progetti",
            contacts: "Contatti",
            links: "Collegamenti",
            italy: "Italia",
            send: "Invia",
            address: "Indirizzo",
            solutions: "Servizi",
            titleCarouselHome1: "Servizi",
            titleCarouselHome2: "Progettazione",
            titleCarouselHome3: "Consulenza",
            textCarouselHome1: "Le nostre <b>competenze</b> diversificate ci permettono di offrire <b>consulenza aziendale</b> e di assistere lo <b>sviluppo</b> di un progetto dalla sua <b>pianificazione</b> fino alla <b>realizzazione</b>.",
            textCarouselHome2: "Ci occupiamo di progettazioni <b>architettoniche</b>, <b>strutturali</b>, <b>edili</b> e sulla prevenzione degli incendi e sicurezza sui cantieri.",
            textCarouselHome3: "I nostri servizi di consulenza sono finalizzati al <b>soddisfacimento</b> di un ben più ampio ventaglio di esigenze aziendali che vanno dalla gestione dei processi finalizzati al soddisfacimento di <b>requisiti ISO</b>, alla attuazione di corrette prassi aziendali in linea con le principali direttive e norme Nazionali, Europee ed Internazionali.",
            comuneMisterbianco: "Comune di Misterbianco",
            comuneBelpasso: "Comune di Belpasso",
            comuneBronte: "Comune di Bronte",
            comunePaterno: "Comune di Paternò",
            comuneBiancavilla: "Comune di Biancavilla",
            comuneMessina: "Comune di Messina",
            ternaSpa: "Terna SpA",
            cardilloAlluminio: "Cardillo Alluminio"
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "it",
        fallbackLng: "en",
        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
